import {
    configureStore
} from '@reduxjs/toolkit'
import {
    combineReducers
} from 'redux'

import about from './slices/about'
import career from './slices/career'
import clients from './slices/clients'
import contact from './slices/contact'
import global from './slices/global'
import home from './slices/home'
import projects from './slices/projects'
import search from './slices/search'
import services from './slices/services'
import team from './slices/team'

const reducer = combineReducers({
    about,
    career,
    clients,
    contact,
    global,
    home,
    projects,
    search,
    services,
    team,
})

const store = configureStore({
    reducer,
})

export default store;
